﻿export default  {
    "oneoneroa-banner": {
        spaceBetween: 30,
        effect: "fade",
        autoplay: {
            delay: 3500,
            disableOnInteraction: true
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        }
    }
}